module.exports = __webpack_public_path__ + "static/media/floorPlanFloor2.66364efc.png";